// assets/remove-links.js
document.addEventListener('DOMContentLoaded', function () {
  // Common selectors Warehouse may use for rich text product descriptions
  var selectors = [
    '.product__description',   // common Warehouse selector
    '.product-description',    // fallback
    '.rte',                    // rich text editor container
    '.product-single__description', // alternate
    '.product-desc'            // alternate
  ];

  // find the first matching element on the page
  var desc = document.querySelector(selectors.join(', '));
  if (!desc) return;

  // Replace each anchor with its text (trim to remove extra spaces)
  desc.querySelectorAll('a').forEach(function (a) {
    var txt = (a.textContent || a.innerText || '').trim();
    // create text node — preserves surrounding formatting/structure
    var textNode = document.createTextNode(txt);
    a.replaceWith(textNode);
  });
});
